import script from "./GridTileView.vue?vue&type=script&setup=true&lang=ts"
export * from "./GridTileView.vue?vue&type=script&setup=true&lang=ts"

import "./GridTileView.vue?vue&type=style&index=0&id=4b12d31e&scoped=true&lang=css"

import exportComponent from "/Users/samuel/KTH/DynWeb/ssoderbe-wrmvd-ht22-project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b12d31e"]])

export default __exports__